import { MijnRoute } from '../../mijn-navigatie.model';

export const INCASSO_BATCHES_SIGN: MijnRoute = {
    path: 'sign',
    navigationEvent: 'toIncassobatchesSign',
    regex: /^\/incassobatches\/sign$/,
    webcomponent: 'mijn-incassobatches-webcomponent',
    internalPath: '/sign'
};
